import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import BriaSlider, { IBriaSliderProps } from "../../../../../../../components/common/BriaSlider/BriaSlider";
import { useAppStore } from "../../../../../../../hooks/useStores";
import { isLegacyTgDemoRoute, isLegacyTgRoute } from "../../../../../../NewTG/utils/tg-utils.ts";

const TextToImageGuidanceSlider = ({ ...props }: IBriaSliderProps) => {
	const { t } = useTranslation("image_generation", { keyPrefix: "playground.textToImage.config.textGuidanceScale" });
	const { textToImageStore } = useAppStore();

	const isFast = textToImageStore.config?.fast;

	useEffect(() => {
		if (!textToImageStore.config?.text_guidance_scale) {
			textToImageStore.handleConfigChange("text_guidance_scale", 5.0);
		}
	}, []);

	const isFiboTgPlayground = !(isLegacyTgRoute() || isLegacyTgDemoRoute());

	return (
		<BriaSlider
			value={textToImageStore.config?.text_guidance_scale}
			onChange={(_, v) => textToImageStore.handleConfigChange("text_guidance_scale", v as number)}
			step={isFiboTgPlayground ? 1 : 0.1}
			min={isFiboTgPlayground ? 3 : 1.0}
			max={isFiboTgPlayground ? 5 : 10.0}
			disabled={isFast || false}
			disabledTooltip={t("disabledTooltip")}
			marks={[
				{ value: isFiboTgPlayground ? 3 : 1.0, label: isFiboTgPlayground ? "3" : "1" },
				{ value: isFiboTgPlayground ? 4 : 5.0, label: isFiboTgPlayground ? "4" : "5" },
				{ value: isFiboTgPlayground ? 5 : 10.0, label: isFiboTgPlayground ? "5" : "10" },
			]}
			valueLabelDisplay="auto"
			{...props}
		/>
	);
};

export default observer(TextToImageGuidanceSlider);
